import { useEffect } from 'react';
import { usePageTracking, usePerformanceTracking, useErrorTracking } from '../../hooks/useAnalytics';

const PageTracker = () => {
  // Automatically track page views
  usePageTracking();
  
  // Track performance metrics
  usePerformanceTracking();
  
  // Track JavaScript errors
  useErrorTracking();

  return null; // This component doesn't render anything
};

export default PageTracker;
